export default "__VITE_ASSET__Dh7r$7Aj__"